const companionEvents = {
    loaded: 'companion.ad.loaded',
    clicked: 'companion.ad.clicked',
    clickError: 'companion.ad.clickError',
    renderError: 'companion.ad.renderError',
    refreshDisplaySlot: 'companion.ad.refresh.slot',
};
export default companionEvents;
